import React from 'react';
import { Link } from 'react-router-dom';
import Loading from '../Loading';
import Routes from '../../Shared/routes';
import Channel from '../../Entities/Channel';


interface IProps {
    list: Channel[];
    error: string;
    remove: (organizationId: number) => void;
    add: () => void;
    isLoading: boolean;
}

export default class ChannelList extends React.Component<IProps> {

    onAddSource = () => {
        this.props.add();
    }

    renderItem = (item: Channel) => {
        return (
            <tr>
                <td>{item.getId()}</td>
                <td>{item.name}</td>
                <td>{item.address}</td>
                <td>
                    <Link to={`${Routes.CHANNEL_EDIT}${item.getId()}`}>Редактировать</Link><br />
                    <Link to={`${Routes.EMPLOYEE_LIST_BY_CHANNEL}${item.getId()}`}>Операторы</Link><br />
                    <Link to={`${Routes.DEPARTMENT_LIST}${item.getId()}`}>Отделы</Link><br />
                    {/* <Link to={`${Routes.ORGANIZATION_EDIT}${item.getId()}`}>Редактировать</Link><br /> */}
                    <a href="#" onClick={() => this.props.remove(item.getId())}>Удалить</a>
                </td>
            </tr>
        )
    }

    render() {
        const { isLoading, list } = this.props;
        if (isLoading) {
            return <Loading />;
        }
        else {
            return (
                <>

                    <div className="app-title">
                        <div>
                            <h1><i className="fa fa-th-list"></i> Каналы</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <div className="tile">
                                <button
                                    onClick={this.onAddSource}
                                    className="btn btn-primary"
                                    type="submit">Добавить канал</button>
                                <br />
                                <br />
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Название</th>
                                            <th>Адресс</th>
                                            <th>Действия</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map(this.renderItem)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    }
}